export const AGENT_OVERLAY_LAYER_PREFIX = "agent-dataset:";
export const AGENT_OVERLAY_METADATA_KEY = "maputnik:role";
export const AGENT_OVERLAY_ROLE = "overlay";
